<template>
  <div class="form-section">
    <h4>Bot Threshold Settings</h4>

    <FormGroup label="Intent confidence thresholds" tooltip="This number determines the top thresholds which the bot asks for clarification of the intent.">
      <div class="row">
        <div class="col-md-6">
          <p class="label">High Level Percentage</p>
          <input type="number" step="5" min="60" max="100" id="threshold" :value="settings.confidence * 100" @change="setThresholdHigh($event)" />
        </div>
        <div class="col-md-6">
          <p class="label">Low Level Percentage</p>
          <input
            type="number"
            step="5"
            min="20"
            max="55"
            id="thresholdlow"
            :value="(settings.lowConfidence * 100).toFixed(0)"
            @change="setThresholdLow($event)"
          />
        </div>
      </div>
    </FormGroup>

    <h4>LLM Chit-Chat Settings</h4>

    <Toggle
      label="Enable Chit-Chat"
      tooltip="Instead of automatic redirection to the None intent you can enable LLM chit-chat."
      v-model="settings.chitChatEnabled"
    />

    <FormGroup :label="`Initiate chit-chat when no intent is recognized ${this.settings.belowThresholdLimit} time(s)`" v-if="settings.chitChatEnabled">
      <div class="row">
        <div class="col-md-6">
          <input type="number" min="1" v-model="settings.belowThresholdLimit" :disabled="!hasSufficientPermission" @change="setBelowThresholdLimit($event)" />
        </div>
      </div>
    </FormGroup>

    <FormGroup v-if="settings.chitChatEnabled" label="Model and Engine">
      <Dropdown :items="OpenAIModels" v-model="settings.chitChatModel" :disabled="!hasSufficientPermission" />
    </FormGroup>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import FormGroup from '../../../../../helpers/FormGroup.vue'
import Toggle from '../../../../../helpers/Toggle.vue'
import { Permissions } from '../../../../../../../../common/enums/tenant/user-permissions.enum'
import permissionsService from '../../../../../../services/tenants/permissions.service'
import Select from '../../../../../helpers/Select.vue'
import { OpenAIModels } from '../../../../../../../../common/enums/open-ai-models'
import Dropdown from '@/components/helpers/Dropdown.vue'

@Component({ components: { FormGroup, Toggle, Select, Dropdown } })
export default class BotIntentRecognizerSettings extends Vue {
  @Prop() readonly settings: any
  @Prop() readonly botName: string

  private hasSufficientPermission = false
  private OpenAIModels = OpenAIModels

  mounted() {}

  async created() {
    this.hasSufficientPermission = await permissionsService.hasPermission(this.botName, Permissions.ManageGeneralSettings)
  }

  setThresholdHigh(event: any) {
    this.settings.confidence = event.target.value / 100
  }

  setThresholdLow(event: any) {
    this.settings.lowConfidence = event.target.value / 100
  }

  setChitChatModel(event: any) {
    this.settings.chitChatModel = event
  }
}
</script>

<style lang="scss" scoped></style>
